/** A leadlista időszak-előbeállításai; a határok budapesti naptári napok (ÉÉÉÉ-HH-NN), az `ig` napot is beleértve. */
export type IdoszakKulcs = 'barmikor' | 'ma' | 'het' | 'harminc' | 'ez_a_honap' | 'elozo_honap' | 'egyedi';
export interface Tartomany { tol: string | null; ig: string | null }

export const IDOSZAK_CIMKE: Record<IdoszakKulcs, string> = {
  barmikor: 'Bármikor', ma: 'Ma', het: 'Elmúlt 7 nap', harminc: 'Elmúlt 30 nap',
  ez_a_honap: 'Ez a hónap', elozo_honap: 'Előző hónap', egyedi: 'Egyedi időszak',
};

const MA_FORMAZO = new Intl.DateTimeFormat('sv-SE', { timeZone: 'Europe/Budapest', year: 'numeric', month: '2-digit', day: '2-digit' });
const NAP_MS = 86_400_000;

const budapestiMa = (nowMs: number): string => MA_FORMAZO.format(new Date(nowMs));
/** Naptári nap eltolása; délre állítva, hogy az óraátállítás ne számítson. */
const napEltolas = (datum: string, nap: number): string => new Date(Date.parse(`${datum}T12:00:00Z`) + nap * NAP_MS).toISOString().slice(0, 10);

export function idoszakTartomany(kulcs: Exclude<IdoszakKulcs, 'egyedi'>, nowMs: number): Tartomany {
  const ma = budapestiMa(nowMs);
  const honapEleje = `${ma.slice(0, 8)}01`;
  switch (kulcs) {
    case 'barmikor': return { tol: null, ig: null };
    case 'ma': return { tol: ma, ig: ma };
    case 'het': return { tol: napEltolas(ma, -6), ig: ma };
    case 'harminc': return { tol: napEltolas(ma, -29), ig: ma };
    case 'ez_a_honap': return { tol: honapEleje, ig: ma };
    case 'elozo_honap': {
      const utolso = napEltolas(honapEleje, -1);
      return { tol: `${utolso.slice(0, 8)}01`, ig: utolso };
    }
  }
}

const ELOBEALLITASOK: Exclude<IdoszakKulcs, 'egyedi'>[] = ['barmikor', 'ma', 'het', 'harminc', 'ez_a_honap', 'elozo_honap'];

export function idoszakKulcs(t: Tartomany, nowMs: number): IdoszakKulcs {
  return ELOBEALLITASOK.find((k) => {
    const x = idoszakTartomany(k, nowMs);
    return x.tol === t.tol && x.ig === t.ig;
  }) ?? 'egyedi';
}

export { ELOBEALLITASOK };
